import { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  Link,
  useLocation
} from 'react-router-dom';
import './App.css';
import { NAV, EMAIL, LINKEDIN } from './content';
import Home from './pages/Home';
import Services from './pages/Services';
import Flight from './pages/Flight';
import Vision from './pages/Vision';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/flight" element={<Flight />} />
        <Route path="/services/visual-intelligence" element={<Vision />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CtaBand />
      <Footer />
    </BrowserRouter>
  );
}

// Router keeps the old scroll offset on navigation; the design is page-based,
// so every route change starts at the top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="hdr">
      <div className="hdr__in">
        <Link className="brand" to="/" aria-label="Wanda Analytics — home">
          <img className="brand__mark" src="/assets/wanda-mark.png" alt="" width="32" height="32" />
          <span className="brand__n">Wanda</span>
          <span className="brand__s">Analytics</span>
        </Link>

        <button
          className="burger"
          type="button"
          aria-expanded={open}
          aria-label="Toggle navigation"
          onClick={() => setOpen((v) => !v)}
        >
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
            {open ? (
              <path d="M3 3l10 10M13 3L3 13" />
            ) : (
              <path d="M1 4h14M1 8h14M1 12h14" />
            )}
          </svg>
        </button>

        <nav className={`nav${open ? ' is-open' : ''}`}>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

// The closing call to action repeats on every page except the contact page,
// where it would sit directly under the form it points at.
function CtaBand() {
  const { pathname } = useLocation();
  if (pathname === '/contact') return null;
  return (
    <section className="section">
      <div className="wrap cta">
        <h2>Tell us what you need to see.</h2>
        <Link className="btn btn--primary" to="/contact">
          Start a conversation
        </Link>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer>
      <div className="ftr__in">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
            <img
              src="/assets/wanda-mark.png"
              alt=""
              width="30"
              height="30"
              style={{ border: '1px solid var(--line-hi)', background: '#0E1014' }}
            />
            <span className="brand__n" style={{ fontSize: 13 }}>
              Wanda Analytics
            </span>
          </div>
          <a href={`mailto:${EMAIL}`} style={{ display: 'inline-block', marginTop: 16, fontSize: 14, color: 'var(--text-dim)' }}>
            {EMAIL}
          </a>
        </div>

        <div className="ftr__col">
          <div className="ftr__h">Services</div>
          <Link to="/services/flight">Flight Operations &amp; Image Capture</Link>
          <Link to="/services/visual-intelligence">AI and Machine Learning</Link>
        </div>

        <div className="ftr__col">
          <div className="ftr__h">Company</div>
          <Link to="/products">Products &amp; Innovation</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="ftr__col">
          <div className="ftr__h">Follow</div>
          <a href={LINKEDIN} target="_blank" rel="noreferrer">
            LinkedIn &#8599;
          </a>
        </div>
      </div>

      <div className="ftr__legal">
        <div>
          <span>&copy; {new Date().getFullYear()} Wanda Analytics</span>
          <span>Image capture &middot; Visual intelligence &middot; Innovation</span>
        </div>
      </div>
    </footer>
  );
}
